'use strict';

var angular = require('angular');
var _ = require('lodash');
var ConfigurationParametersNavigationDirective = function ConfigurationParametersNavigationDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-parameters-navigation.html'),
    controller: 'ConfigurationParametersNavigationController',
    link: function link($scope, element) {
      var tablePlaceholder = element.find('.table-placeholder');
      var simpleHepTemplate = _.template(require('../templates/simple-hep-grid-table.html'));
      var advancedHepTemplate = _.template(require('../templates/advanced-hep-level-tree-grid-table.html'));
      element.on('click', 'tr[type]>td:first-child', function (event) {
        var type = angular.element(event.currentTarget).parent().attr('type');
        $scope.collapseHandler(type);
        $scope.$apply();
      });
      element.on('click', 'input[type=radio]', function (event) {
        var target = angular.element(event.currentTarget);
        var hierarchy = target.attr('value');
        var type = target.closest('tr').attr('parent-type');
        $scope.updateHepSelection(hierarchy, type);
        $scope.$apply();
      });
      $scope.render = function () {
        var templateFunction = _.isUndefined($scope.configType) || $scope.isSimpleHep() ? simpleHepTemplate : advancedHepTemplate;
        var html = templateFunction($scope);
        tablePlaceholder.html(html);
      };
      $scope.$watch('configType', function (newConfigType) {
        if (!_.isUndefined(newConfigType)) {
          $scope.initializeNavigation(newConfigType);
        }
      });
    }
  };
};
ConfigurationParametersNavigationDirective.$inject = [];
module.exports = ConfigurationParametersNavigationDirective;